import styled from 'styled-components'

import { PADDING_TEXT } from 'components/Button/ButtonStyled'

export const StyledHyperlink = styled.div`
  padding: 0 ${PADDING_TEXT}px;
`
